module.exports = __webpack_public_path__ + "assets/bbf5c542.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sale-orange.png
// module id = 103
// module chunks = 0